import { Drawer } from 'components/Drawer'
import { Button } from 'blaze-components/WriterTopBar/Button'
import { Heading } from 'blaze-ui/Heading/Heading'
import { useState } from 'react'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { useLinkSelection } from 'common/Prose/Toolbar/hooks/useLinkSelection'
import { LinkModalProps } from 'common/LinkModal/Types'
import { AddLink } from 'common/Prose/Toolbar/MobileWriterFormatBar/AddLink'
import { LinkToHeading } from 'common/Prose/Toolbar/MobileWriterFormatBar/LinkToHeading'
import { ChevronLeft } from 'blaze-ui/icons/24'
import { observer } from 'mobx-react-lite'
import { useLayout } from 'stores/LayoutStore'
import { useRootStore } from 'stores/RootStore'
import { DrawerProps } from 'components/Drawer/Root'

interface Props extends DrawerProps {
  onRemoveLink?: () => void
  initialText?: string
  initialQuery?: string
}

export const LinkDrawer = observer(({ onRemoveLink, initialText, initialQuery = '', ...props }: Props) => {
  const view = useEditorView()
  const drawersStore = useRootStore().drawersStore
  const { turnSelectionIntoLink } = useLinkSelection()
  const [isLinkHeading, setLinkHeading] = useState(false)
  const layout = useLayout()

  const close = () => drawersStore.closeDrawer()

  const handleLinked: LinkModalProps['callback'] = ({ link, text }) => {
    turnSelectionIntoLink(link, text)
  }

  const [text, setText] = useState(() => {
    if (initialText) return initialText

    const { from, to } = view.state.selection
    return view.state.doc.textBetween(from, to)
  })

  return (
    <Drawer.Root
      {...props}
      onOpen={() => view.dispatch(view.state.tr.scrollIntoView())}
      onClose={() => {
        setLinkHeading(false)
        view?.focus()
      }}
    >
      <Drawer.Portal>
        <Drawer.Overlay />
        <Drawer.Content layoutViewport={layout.viewport}>
          <Drawer.InnerContent>
            <Drawer.Top>
              <div>
                {!isLinkHeading && <Drawer.Close />}
                {isLinkHeading && <Button onPress={() => setLinkHeading(false)} icon={ChevronLeft} />}
              </div>
              <Drawer.Title asChild>
                <Heading level={5}>Add a Link or Mention</Heading>
              </Drawer.Title>
            </Drawer.Top>
            <Drawer.Container>
              {!isLinkHeading && (
                <AddLink
                  text={text}
                  initialQuery={initialQuery}
                  onLinked={handleLinked}
                  onClose={close}
                  onChange={setText}
                  onLinkHeading={() => setLinkHeading(true)}
                  onRemoveLink={
                    onRemoveLink &&
                    (() => {
                      onRemoveLink()
                      close()
                    })
                  }
                />
              )}
              {isLinkHeading && <LinkToHeading onLinked={handleLinked} onClose={close} text={text} />}
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
})
